import { render, staticRenderFns } from "./SamplingStation.vue?vue&type=template&id=10cd033a"
import script from "./SamplingStation.vue?vue&type=script&lang=js"
export * from "./SamplingStation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports